import * as React from "react";
import { getQueryString } from "public@tool/getQuery";
import { action } from "../../action/index";
import { observer, inject } from "mobx-react";
import "./style/style.scss";
import HeaderComponent from "../../component/header";
import PlayerComponent from "../../component/player";
import SidebarComponent from "../../component/sidebar";
// import AnimationComponent from '../../../Public/OperationComponent/animation/index';

const PATH_NAME = window.location.pathname;
const REPLACE_LIVEID = /\/live\/v/.test(PATH_NAME)
  ? PATH_NAME.replace(/\/live\/v\/(.*)$/, "$1")
  : false;
const liveId: any = !!REPLACE_LIVEID ? REPLACE_LIVEID : getQueryString("liveId");

@inject("store")
@observer
export default class HomeView extends React.Component<any, any> {
  public componentDidMount() {
    action.getInitData(liveId);
  }

  public render() {
    const { _loading } = this.props.store;
    return (
      <div>
        {_loading ? (
          <div className="live__init--loading">{/* <AnimationComponent /> */}</div>
        ) : (
          <div className="pc-container">
            <div className="pc-main">
              <div className="pc-header">
                <HeaderComponent />
              </div>

              <div className="pc-play">
                <PlayerComponent />
              </div>
            </div>

            <div className="pc-chat-info">
              <SidebarComponent />
            </div>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pc/view/home/index.tsx